import CryptoJS from "crypto-js";
import { audioNotificar } from "../../../helpers/audioNotificar";

const URLWINDOWS = process.env.REACT_APP_API_URL_WINDOW;

/**
 * Genera un código aleatorio siguiendo un patrón de alternancia entre consonantes y números.
 *
 * @param {number} limit - La longitud deseada del código a generar.
 * @returns {string} - Un código aleatorio generado siguiendo el patrón de alternancia.
 */
export const generateRandomCode = (limit) => {
  // const consonants = "BCDFGHJKLMNPQRSTVWXYZ"; // Removed "A" since it's already included
  const numbers = "123456789";
  let code = "";

  for (let i = 0; i < limit; i++) {
    // const source = i % 2 === 0 ? consonants : numbers;
    const source = numbers;
    code += source.charAt(Math.floor(Math.random() * source.length));
  }

  return code;
};

/**
 * Genera un nuevo tiempo al sumar un tiempo de espera a un tiempo dado.
 *
 * @param {string} time - El tiempo en formato 'hh:mm:ss' al que se le sumará el tiempo de espera.
 * @returns {string} - Un nuevo tiempo en formato 'hh:mm:ss' que resulta de sumar el tiempo de espera.
 */

export const generateWaitingTime = (time, waitTime) => {
  let minute = time.slice(3, 5);
  let hour = time.slice(0, 2);
  if (Number(minute) + waitTime < 60) {
    minute = Number(minute) + waitTime;
  } else {
    minute = Number(minute) + waitTime - 60;
    hour = Number(hour) + 1;
  }
  if (Number(minute) < 10) {
    minute = `0${minute}`;
  }
  const newTime = `${hour}:${minute}:${time.slice(6, 8)}`;
  return newTime;
};

/**
 * Genera un arreglo de notificaciones de horarios basado en los parametros proveidos.
 *
 * @param {Object} schedule - El horario base que contiene la hora de inicio
 * @param {number} notificationNumber - El numbero de notificaciones.
 * @returns {string[]} Un arreglo de notificaciones de horarios en formato "HH:mm:ss".
 */

export const getNotificationSchedules = (schedule, notificationNumber) => {

  let timesRandom = [];
  let dividedNumber = Math.floor(90 / notificationNumber);
  
  for (let i = 0; i < notificationNumber; i++) {
    let numberRandom = Math.floor(Math.random() * dividedNumber);
    //Garantiza que el intervalo generado sea al menos la mitad del segmento.
    if (numberRandom < dividedNumber / 2) {
      numberRandom += dividedNumber / 2;
    }
    timesRandom.push(numberRandom);
  }
  const hourStart = [schedule.hora_inicio.slice(0, 5)];

  const schedulesNotification = timesRandom.reduce(
    (ac, val) => {
      let scheduleAc = ac.schedules[ac.schedules.length - 1];
      let notificationHour = "";

      let hour = scheduleAc.slice(0, 2);
      let minute = scheduleAc.slice(3, 5);

      let sumOfMinutes = val + +minute;
      if (sumOfMinutes > 59) {
        hour = 1 + +hour;
        if (hour < 10) {
          hour = `0${hour}`;
        }
        minute = sumOfMinutes - 60;
        if (minute < 10) {
          minute = `0${minute}`;
        }
        notificationHour = `${hour}:${minute}:00`;
      } else {
        if(val + +minute < 10) {
          minute = `0${val + +minute}`
        }
        notificationHour = `${hour}:${val + +minute}:00`;
      }

      let newArray = ac.schedules;
      newArray.push(notificationHour);
      return {
        schedules: newArray,
      };
    },
    { schedules: hourStart }
  );

  return schedulesNotification.schedules;
};

export const decryptString = (encryptedString, key) => {
  const decrypted = CryptoJS.AES.decrypt(encryptedString, key);
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const encryptString = (string, key) => {
  const encrypted = CryptoJS.AES.encrypt(string, key);
  return encrypted.toString();
};

export const openWindowNotification = (urlView) => {
  let url = `${URLWINDOWS}${urlView}`;
  var screenWidth = window.screen.availWidth;
  var screenHeight = window.screen.availHeight;
  var windowWidth = 500; // Desired width of the window
  var windowHeight = 300; // Desired height of the window

  var leftPosition = screenWidth - windowWidth;
  var topPosition = screenHeight - windowHeight;
  const windowOpen = window.open(url,"_blank","left=" +leftPosition + ",top=" + topPosition + ",width=" + windowWidth + ",height=" + windowHeight);
  audioNotificar()
  return windowOpen;
};


export const getDateFormatYMD = () => {
  // Obtener la fecha actual
  const fecha = new Date();

  // Obtener los componentes de la fecha
  const anio = fecha.getFullYear().toString();
  const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); 
  const dia = fecha.getDate().toString().padStart(2, '0');

  // Formatear la fecha en el nuevo formato
  const fechaFormateada = `${anio}-${mes}-${dia}`;

  return fechaFormateada;
}


export const calculateDifferenceBetweenTimes = (hora1, hora2) => {
  // Parsear las horas en objetos Date
  const fechaInicio = new Date(`1970-01-01T${hora1}`);
  const fechaFin = new Date(`1970-01-01T${hora2}`);

  // Calcular la diferencia en milisegundos
  const diferenciaMilisegundos = fechaFin - fechaInicio;

  // Calcular horas, minutos y segundos a partir de la diferencia en milisegundos
  const hours = Math.floor(diferenciaMilisegundos / (60 * 60 * 1000));
  const minutes = Math.floor((diferenciaMilisegundos % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((diferenciaMilisegundos % (60 * 1000)) / 1000);

  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}